import Base    from './base';
import Storage from './storage';

export default {
    Storage,
    Base
};
